import { CHANGE_SCREEN } from './actionTypes';

export function changeScreen(screen) {
  return { type: CHANGE_SCREEN, screen };
}
